import React from "react";
import "./Prize.css";

export function Prize() {
  return (
    <section className="prize" id="premio">
      <div className="container prize__content">
        <h2 className="prize__title" data-reveal>O Prêmio que vai mudar a sua rota!</h2>

        <p className="prize__intro" data-reveal style={{ "--reveal-delay": "100ms" } as React.CSSProperties}>
          Você está pronto para uma transformação? Participar do De Carona com Toro é mais do que um evento, é uma oportunidade de mudar sua trajetória. <br />
          <strong>E temos um prêmio especial esperando por você.</strong>
        </p>
        {/* <p className="prize__value" data-reveal style={{ "--reveal-delay": "200ms" } as React.CSSProperties}>R$ 150.000,00!</p>

        <p className="prize__description" data-reveal style={{ "--reveal-delay": "100ms" } as React.CSSProperties}>
          O prêmio é entregue em um cartão (sem função de saque ou
          transferência, válido por 180 dias). A nossa sugestão? Que você use
          esses 150 mil reais para comprar a sua Fiat Toro 0km (cotação de
          maio/2026)!
        </p> */}

        <p className="prize__highlight" data-reveal style={{ "--reveal-delay": "200ms" } as React.CSSProperties}>
          Seja acelerando seus sonhos ou investindo em seu futuro, <span>o prêmio é todo seu!</span> Descubra o que você pode ganhar.
        </p>
      </div>
    </section>
  );
}
